import * as React from "react";
const SvgFiRrKerning = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-kerning_svg__a)">
      <path
        fill="#062147"
        d="m16.94 1.342-8 22a1 1 0 0 1-1.88-.684l8-22a.999.999 0 1 1 1.88.683M9.908 6.059a1 1 0 0 0-1.278.605l-3.344 9.362-3.344-9.362a.999.999 0 1 0-1.884.672l3.805 10.653a1.5 1.5 0 0 0 1.423 1.002c.647 0 1.205-.394 1.422-1.003l3.805-10.652a1 1 0 0 0-.605-1.277m13.428 12.883a1 1 0 0 1-1.278-.605L20.866 15h-4.305l-1.19 3.336a.999.999 0 1 1-1.883-.672l3.804-10.652a1.49 1.49 0 0 1 1.422-1.003c.647 0 1.206.394 1.423 1.002l3.805 10.653a1 1 0 0 1-.606 1.277M20.152 13l-1.438-4.026L17.276 13z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-kerning_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrKerning;
